module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/most0-1f6a9beee7b4f19ffcbda876db83e81c.jpg";